import React, { createContext, useContext, useState } from "react";

const UserFilesContext = createContext();

export const UserFilesProvider = ({ children }) => {
  const [userFiles, setUserFiles] = useState(undefined);

  return (
    <UserFilesContext.Provider value={{ userFiles, setUserFiles }}>
      {children}
    </UserFilesContext.Provider>
  );
};

export const useUserFiles = () => useContext(UserFilesContext)